var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228 175",
    width: 228,
    height: 175,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo04-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.59-6.15h237.18v180.3h-237.18z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #193c34;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t\t.s1 { fill: none;stroke: #e8ba3a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 4 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m11.4 161.5c0-3.3 2.6-6 5.9-6h195.4c3.3 0 5.9 2.7 5.9 6v2.2c0 3.3-2.6 6-5.9 6h-195.4c-3.3 0-5.9-2.7-5.9-6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2781",
    fillRule: "evenodd",
    className: "s1",
    d: "m91.7 45.3h10.7c2.5 0 4.5-2 4.5-4.5 0-2.5-2-4.5-4.5-4.5h-4.9c-2.4 0-4.4-1.9-4.4-4.3 0-2.4 2-4.3 4.4-4.3h8.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2785",
    fillRule: "evenodd",
    className: "s1",
    d: "m99.3 27.7v-5.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2789",
    fillRule: "evenodd",
    className: "s1",
    d: "m99.3 50.8v-5.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2793",
    fillRule: "evenodd",
    className: "s0",
    d: "m123.2 36.5c0 13.2-10.7 23.9-23.9 23.9-13.2 0-23.9-10.7-23.9-23.9 0-13.2 10.7-23.9 23.9-23.9 13.2 0 23.9 10.7 23.9 23.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2797",
    fillRule: "evenodd",
    className: "s0",
    d: "m94.5 59.9v13.4h-6l10.8 13.8 10.9-13.8h-6v-13.4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m125.2 68.1h60.5v9.2h-60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m158.7 146.9h-33.5c-9.8-27.8 0-69.6 0-69.6h60.5c0 0 6.9 29.3 2.6 54.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m159.5 146.9h-34.3v8.6h82.5c0 0 0-4.4-5-5.7 0 0-0.1-7.5-6.7-7.5 0 0 1.7-7.9-7.1-8.4 0 0-1.7-7.6-8.5-7.2-7.3 0.5-7.9 7.7-7.9 7.7 0 0-6 0.2-6.6 7.6 0 0-6.9 1.1-6.6 7.5 0 0-5.2 0.1-5.2 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m154.3 109.3v17.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m150.9 118.4l3.4 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m157.8 118.4l-3.5 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m157.8 117.9c0.2-1.4 1.6-9.1 10.1-8.1 0.1 0 0.2 0.1 0.2 0.2-0.1 1.4-1.1 9.4-10.1 8.2-0.1 0-0.2-0.2-0.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m150.6 117.9c-0.2-1.4-1.7-9.1-10.1-8.1-0.1 0-0.2 0.1-0.2 0.2 0.1 1.4 1.1 9.4 10.1 8.2 0.1 0 0.2-0.2 0.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m154.6 109.6c1.2-1.3 7.8-8.3 0.7-16-0.1-0.1-0.3-0.1-0.4 0-1.3 1.1-8.6 7.9-0.7 16 0.1 0.1 0.2 0.1 0.4 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4239",
    fillRule: "evenodd",
    className: "s0",
    d: "m39.8 148.9v-8.2h48.7v8.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4247",
    fillRule: "evenodd",
    className: "s0",
    d: "m39.8 112.5v-12.5c0-2 1.6-3.6 3.6-3.6h41.5c2 0 3.6 1.6 3.6 3.6v18.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4251",
    fillRule: "evenodd",
    className: "s0",
    d: "m39.8 144.1v-32.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4255",
    fillRule: "evenodd",
    className: "s1",
    d: "m71.2 120.3h-14.1c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3 3.1-3h14.1c1.7 0 3.1 1.3 3.1 3 0 1.7-1.4 3.1-3.1 3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4271",
    fillRule: "evenodd",
    className: "s0",
    d: "m54.1 96.4h-10.6c-0.8 0-1.5-0.7-1.5-1.6v-5.1c0-0.8 0.7-1.5 1.5-1.5h10.6c0.8 0 1.5 0.7 1.5 1.5v5.1c0 0.9-0.7 1.6-1.5 1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4275",
    fillRule: "evenodd",
    className: "s0",
    d: "m52.8 88.2h-8.1v-10.3c0-0.9 0.7-1.5 1.5-1.5h5.1c0.9 0 1.5 0.6 1.5 1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4279",
    fillRule: "evenodd",
    className: "s0",
    d: "m31.7 103.4v42.7c0 1.7 1.4 3 3.1 3h5v6.4h48.7v-6.6l-48.7 0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4283",
    fillRule: "evenodd",
    className: "s1",
    d: "m31.7 103.5c-1.2 0-2.3-1.1-2.3-2.3v-14.2c0-1.3 1.1-2.3 2.3-2.3 1.3 0 2.3 1 2.3 2.3v14.2c0 1.2-1 2.3-2.3 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4287",
    fillRule: "evenodd",
    className: "s0",
    d: "m52.8 80.5h6.3c2.8 0 5 2.3 5 5.1v10.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4319",
    fillRule: "evenodd",
    className: "s0",
    d: "m83.6 115.4l-12.3-33.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4323",
    fillRule: "evenodd",
    className: "s0",
    d: "m95.9 149c0.7 1.8 2.4 3 4.4 3 2.6 0 4.7-2.1 4.7-4.8v-30.4c0-3.7-2.9-6.6-6.6-6.6h-9.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4307",
    fillRule: "evenodd",
    className: "s0",
    d: "m85.1 128.8l6.1 17c0.6 1.7 2.5 2.6 4.3 2 1.7-0.7 2.6-2.6 1.9-4.3l-10.6-29.3-6.2 2.3 2 5.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m69.1 82.3v-5l3.8 3.5-3.8 1.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo04);
export default __webpack_public_path__ + "static/media/logo04.a3fae4e236337a9e5c8bf43db85dc9fd.svg";
export { ForwardRef as ReactComponent };